import { Progress } from "antd";
import { CascadeFailed } from "components/UI/Cascade/CascadeFailed.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { useEffect, useState } from "react";

export const CascadeProcessing = () => {
    const { t } = usePaldockTranslation("ui.cascade");
    const [timeLeft, setTimeLeft] = useState(120);
    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
            return () => clearInterval(timer);
        }
    }, [timeLeft]);

    const formatTime = (seconds: number) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}`;
    };

    const progressPercent = (timeLeft / 120) * 100;

    return (
        <>
            <div className={"flex flex-col gap-2 items-center justify-center"}>
                {timeLeft === 0 ? (
                    <CascadeFailed />
                ) : (
                    <>
                        <Progress
                            type="circle"
                            percent={progressPercent}
                            format={() => formatTime(timeLeft)}
                            strokeColor="#3b82f6"
                        />
                        <h1 className="text-2xl font-bold text-gray-800 mt-2 text-bold text-center">
                            {t("content.searching_best_offer")}
                        </h1>
                    </>
                )}
            </div>
        </>
    );
};
